export default __webpack_public_path__ + "static/media/Niftycover_Claims_Management_Framework.eabcb427.pdf";